import { gql, useLazyQuery } from "@apollo/client";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@nextui-org/react";
import { useCallback } from "react";
import { clearUserInfo } from "../redux/userStore";
import { useDispatch } from "react-redux";
import { clearLocalStorage } from "../crypto/utils";
import { useNavigate } from "react-router-dom";
import { useUserInfo } from "../hooks/useUserInfo";
import ProfileAvatar from "./ProfileAvatar";

const LOGOUT_QUERY = gql`
  query Logout {
    logout
  }
`;

enum DropdownKeys {
  Logout = "Logout",
  Profile = "Profile",
  Settings = "Settings",
}

export default function ProfileMenu() {

  const { username, randomUsername, profilePhotoDownloadURL, profilePlaceholder } = useUserInfo();
  const [logoutQuery] = useLazyQuery(LOGOUT_QUERY, { fetchPolicy: "no-cache" });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = useCallback(async () => {
    await logoutQuery();
    dispatch(clearUserInfo());
    clearLocalStorage();
    navigate("/login");
  }, [dispatch, logoutQuery, navigate]);

  const navigateToProfile = useCallback(() => {
    if (!username) {
      return;
    }
    navigate(`/writer/${username}`);
  }, [navigate, username]);

  const navigateToSettings = useCallback(() => {
    navigate("/settings");
  }, [navigate]);

  return (
    <Dropdown className="font-sans">
      <DropdownTrigger>
        <div style={{ minWidth: 40 }}>
          <ProfileAvatar
            className="cursor-pointer"
            src={profilePhotoDownloadURL ?? ""}
            profilePlaceholder={profilePlaceholder}
            style={{ width: 40, height: 40 }}
          />
        </div>
      </DropdownTrigger>
      <DropdownMenu
        aria-label="Profile menu"
        topContent={
          <div
            style={{
              color: "#7194A8",
              paddingLeft: 8,
              borderBottomWidth: 1,
              borderBottomColor: "#d4d4d8",
              paddingBottom: 4,
            }}
            className="font-sans"
          >
            <p>{username ?? `${randomUsername} (guest)`}</p>
          </div>
        }
      >
        <DropdownItem key={DropdownKeys.Profile} onPress={navigateToProfile}>
          Profile
        </DropdownItem>
        <DropdownItem key={DropdownKeys.Settings} onPress={navigateToSettings}>
          Settings
        </DropdownItem>
        <DropdownItem key={DropdownKeys.Logout} onPress={logout}>
          Logout
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}
